var INTERPOLATE_PATTERN = /%(%|\w+)/g;

/**
 * Interpolates a string, replaces named placeholders denoted by %.
 * % can be escaped by using it twice. Will replace duplicate keys
 * in the string.
 *
 * Example:
 *
 * ```
 * interpolate("Test %percent%%", { percent: 100 }) # => "Test 100%"
 * interpolate("Test %missing", { percent: 100 })
 * # Warning: interpolate: Missing parameter 'missing' in 'Test %missing'.
 * interpolate("Test %missing", { percent: 100 }, 'custom.identifier')
 * # Warning: interpolate: Missing parameter 'missing' in 'custom.identifier'.
 * ```
 */
var interpolate = function interpolate(str, binds, identifier) {
  return str.replace(INTERPOLATE_PATTERN, function (_, key) {
    // Special case for escaped %
    if (key === "%") {
      return "%";
    }
    if (binds && Object.prototype.hasOwnProperty.call(binds, key)) {
      return binds[key].toString();
    }
    if (process.env.NODE_ENV !== "production") {
      console.warn("interpolate: Missing parameter '" + key + "' in '" + (identifier || str) + "'.");
    }
    return "%" + key;
  });
};

export { interpolate };
//# sourceMappingURL=interpolate.js.map
